import { useRef } from "react";
import { CustomModal } from "../../layouts/customModal";
import { Dialog } from "@headlessui/react";

export const Support = () => {
  const modalRef = useRef(null);
  const openRef = useRef(null);

  const handleClose = () => {
    modalRef.current();
  };

  return (
    <CustomModal
      btnText={"Help & Support"}
      modalRef={modalRef}
      openRef={openRef}
      customBtn={
        <div id="modalBtn" className="mt-4 hover:cursor-pointer">
          <span
            onClick={() => {
              openRef.current();
            }}
          >
            {"Help & Support"}
          </span>
        </div>
      }
    >
      <div className="w-100 flex justify-between">
        <Dialog.Title
          as="h3"
          className="text-lg font-medium leading-6 text-gray-900 inline-flex"
        >
          <strong className="flex align-middle">Help & Support</strong>
        </Dialog.Title>
        <button
          type="button"
          onClick={() => handleClose()}
          className="text-gray-500 hover:text-gray-700"
          aria-label="Close dialog"
        >
          ✕
        </button>
      </div>
      <div className="mt-2">
        <p className="text-sm text-gray-500">
          <span>
            Require assistance or have a question? Please reach out to:
          </span>
          <a
            href="mailto:mananl@gomarkets.com"
            className="block mt-2 text-dark"
          >
            mananl@gomarkets.com
          </a>
        </p>
      </div>
    </CustomModal>
  );
};
